import { CompanyLink } from '@aibees/elephant/feature/search-table-company';
import { Nullable } from '@aibees/shared/definition';

export function getCompanyDomain(data?: Nullable<CompanyLink>) {
  return (data?.domain_ltd || data?.domain || data?.website) ?? undefined;
}
